<template>
  <section>
    <!--工具条-->
    <div>
      <el-form :inline="true">
        <el-form-item label="工程名称">
          <el-input v-model="filters.projectName" placeholder="工程名称"></el-input>
        </el-form-item>
        <el-form-item label="起止时间">
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getReportManufactureProject(1)">
          查询
        </el-button>
        <el-button type="primary" @click="downReportManufacture">
          导出
        </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="material" :render-header="labelHead" highlight-current-row v-loading="listLoading"
      style="width: 100%" id="print" border show-summary :summary-method="getSummaries">
      <el-table-column prop="ProductionTime" label="日期"></el-table-column>
      <el-table-column prop="ClientName" label="客户名称"></el-table-column>
      <el-table-column prop="ProjectName" label="工程名称"></el-table-column>
      <el-table-column prop="GradeName" label="强度等级"></el-table-column>
      <el-table-column prop="ProjectPart" label="施工部位"></el-table-column>
      <el-table-column prop="PouringMethodName" label="浇筑方式"></el-table-column>
      <el-table-column prop="SpecMtlName" label="特殊材料"></el-table-column>
      <el-table-column prop="QuantityDelivery" label="发货方量"></el-table-column>
      <el-table-column prop="Quantity" label="生产方量"></el-table-column>
      <el-table-column prop="ItemQuantity" label="盘次方量"></el-table-column>
      <el-table-column prop="CarCount" label="发货车次"></el-table-column>
      <el-table-column v-for="(item, index) in header" :key="index" :prop="item.MatName + '_' + item.WarehouseName"
        :label="item.MatName + '_' + item.WarehouseName"></el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
//引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/command";
import { BaseApiUrl } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Axios from "axios";
import printJS from "print-js";
export default {
  components: { Toolbar },
  data() {
    return {
      currentRow: null,
      filters: {
        projectName: "",
        startTime: "",
        endTime: "",
        page: 1,
        intPageSize: 10,
        orgCode: "",
      },
      total: 0,
      sumData: {},
      material: [],
      header: [],
      listLoading: false,
    };
  },
  computed: {},
  methods: {
    labelHead(h, { column, index }) {
      //动态表头渲染
      //let l = column.label.length;
      //let f = 12; //每个字大小,其实是每个字的比例值,大概会比字体大小打差不多大
      //column.minWidth = f * l; //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
      //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("span", { class: "table-head", style: { width: "100%" } }, [
        column.label,
      ]);
    },
    getSummaries(param) {
      var sums = [];
      sums[0] = "";
      sums[1] = "合计";
      sums[2] = "";
      sums[3] = "";
      sums[4] = "";
      sums[5] = "";
      sums[6] = "";
      sums[7] = this.sumData.QuantityDelivery;
      sums[8] = this.sumData.Quantity;
      sums[9] = this.sumData.ItemQuantity;
      sums[10] = this.sumData.CarCount;
      var index = 11;
      this.header.map((e) => {
        sums[index] = e.Quantity;
        index += 1;
      });
      return sums;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReportManufactureProject();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getReportManufactureProject(1);
    },
    //获取原材料消耗
    getReportManufactureProject(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      api.GetReportManufactureProject(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.header = res.data.response.header;
        this.material = res.data.response.data;
        this.sumData = res.data.responsesum;
        this.listLoading = false;
      });
    },
    //导出原材料消耗
    downReportManufacture() {
      let para = this.filters;
      var sheetName = "工程消耗信息";
      api.DownReportManufactureProject(para, sheetName).then((res) => { });
    },
    /** 打印按钮操作 */
    handlePrints(id) {
      const html = document.querySelector("#" + id).innerHTML;
      // 新建一个 DOM
      const div = document.createElement("div");
      const printDOMID = "printDOMElement";
      div.id = printDOMID;
      div.innerHTML = html;

      // 提取第一个表格的内容 即表头
      const ths = div.querySelectorAll(".el-table__header-wrapper th");
      const ThsTextArry = [];
      for (let i = 0, len = ths.length; i < len; i++) {
        if (ths[i].innerText !== "") ThsTextArry.push(ths[i].innerText);
      }

      // 删除多余的表头
      div.querySelector(".hidden-columns").remove();
      // 第一个表格的内容提取出来后已经没用了 删掉
      div.querySelector(".el-table__header-wrapper").remove();

      // 将第一个表格的内容插入到第二个表格
      let newHTML = "<tr>";
      for (let i = 0, len = ThsTextArry.length; i < len; i++) {
        newHTML +=
          '<td style="text-align: center; font-weight: bold">' +
          ThsTextArry[i] +
          "</td>";
      }

      newHTML += "</tr>";
      div
        .querySelector(".el-table__body-wrapper table")
        .insertAdjacentHTML("afterbegin", newHTML);
      // 将新的 DIV 添加到页面 打印后再删掉
      document.querySelector("body").appendChild(div);
      printJS({
        printable: printDOMID,
        type: "html",
        scanStyles: false,
        style:
          "table {  width: 100%; border-collapse: collapse; border-spacing: 0; } table th{ line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: right;} table td{line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: left;}", // 表格样式
      });

      div.remove();
    },formatDate(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
        let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime =this.formatDate(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDate(endDate);
    if (localStorage.currentOrg) {
      let currentOrg = JSON.parse(localStorage.currentOrg);
      this.filters.orgCode = currentOrg.OrgCode;
    } else if (localStorage.sysOrgs) {
      let sysOrgs = JSON.parse(localStorage.sysOrgs);
      this.filters.orgCode = sysOrgs[0].OrgCode;
    }
    this.getReportManufactureProject();
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
